import { Icon } from "@iconify/react";
import "../../css/GlobalStyles.css";
import { CSSProperties, memo } from "react";
import ReactDOM from "react-dom";
import { m, LazyMotion, domAnimation } from "framer-motion";
import { Colors } from "../../utils/colors";
import { ThemeType } from "@markit/common.types";
import { useTheme } from "../../hooks/useTheme";

type MediaExpandedItemProps = {
  mediaUrl: string;
  onClose: () => void;
  hardTheme?: ThemeType;
  imageStyles?: CSSProperties;
};

// Full screen overlay for displaying an expanded media item
const MediaExpandedItem = memo(function MediaExpandedItemFn(
  props: MediaExpandedItemProps
) {
  const { mediaUrl, onClose, hardTheme, imageStyles } = props;
  const { theme } = useTheme(hardTheme);

  // React portal helps to render the component outside of the current DOM hierarchy so that it can be displayed on top of all other elements
  return ReactDOM.createPortal(
    <LazyMotion features={domAnimation}>
      <m.div
        className="Centering ColumnNormal"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.SubComponentBG.backgroundColor,
          zIndex: 1000,
          cursor: "pointer",
          gap: 14,
        }}
        onClick={onClose}
      >
        <img
          src={mediaUrl}
          alt="Expanded media"
          style={{
            maxWidth: "80%",
            maxHeight: "80%",
            objectFit: "contain",
            borderRadius: 8,
            cursor: "default",
            border: `0.5px solid ${theme.EditableTextFieldBorder.borderColor}`,
            ...imageStyles,
          }}
          onClick={(e) => e.stopPropagation()}
        />
        <div
          className="Centering"
          style={{
            backgroundColor: theme.NewPrimaryBG.backgroundColor,
            border: `0.5px solid ${theme.EditableTextFieldBorder.borderColor}`,
            padding: 7,
            borderRadius: 100,
          }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
        >
          <Icon
            icon="ion:close"
            height={20}
            style={{ color: Colors.GRAY1, cursor: "pointer" }}
            onClick={onClose}
          />
        </div>
      </m.div>
    </LazyMotion>,
    document.body
  );
});

export default MediaExpandedItem;
